import React, { Component } from 'react';
import { submit, isSubmitting } from 'redux-form';

import 'react-table/react-table.css';

import { connect } from 'react-redux';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import MoveOutWizardPage from './move_out_creator/moveOutWizardPage';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import {
  postLeaseTermination,
  displayLastBillableDay,
  hideLastBillableDay,
} from 'actions/landlordTenantsActions';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

export default withMobileDialog()(
  connect(
    store => {
      return {
        showPage: store.authentication.showPage,
        leaseDetails: store.leaseDetails.leaseDetails,
        documentToSign: store.landlordTenants.documentToSign,
        pageNumber: store.landlordTenants.pageNumber,
        showLastBillableDay: store.landlordTenants.showLastBillableDay,
        submitting: isSubmitting('move_out_creator_form')(store),
      };
    },
    { submit, postLeaseTermination, displayLastBillableDay, hideLastBillableDay }
  )(
    class MoveOutCreator extends Component {
      onSubmit = async values => {
        await this.props.postLeaseTermination(values, this.props.leaseDetails.id);
        this.props.toggleMoveOutDialog();
        this.props.toggleDrawer();
        this.props.getRentRollData();
      };

      render() {
        return (
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.props.isOpen}
            onClose={this.props.toggleMoveOutDialog}
            aria-labelledby="perform-move-out"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="add-new-asset">
              <h3 style={{ textAlign: 'center', margin: 0 }}>
                Move Out <TenantResidentVerbiageHelper capitalize />
              </h3>
            </DialogTitle>
            <DialogContent style={{ maxWidth: '500px', margin: 'auto' }}>
              <p>
                {' '}
                You can perform a move out by selecting the move out date below. Moving out
                <TenantResidentVerbiageHelper />s will deactivate their portal access on the
                specified date, and allow you to generate leases for this unit.{' '}
              </p>
              <MoveOutWizardPage
                onSubmit={this.onSubmit}
                showLastBillableDay={this.props.showLastBillableDay}
                displayLastBillableDay={this.props.displayLastBillableDay}
                hideLastBillableDay={this.props.hideLastBillableDay}
              />
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.props.toggleMoveOutDialog}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                CANCEL
              </FlatButton>
              <FlatButton
                variant="raised"
                onClick={() => this.props.submit('move_out_creator_form')}
                disabled={this.props.submitting}
                id="submit-button"
                style={{
                  color: 'white',
                  backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
                }}
              >
                MOVE OUT
              </FlatButton>
            </DialogActions>
          </Dialog>
        );
      }
    }
  )
);
